import React, { useEffect } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { attach } from "../../common/componentExtensions";
import ImpiantoForm, { ImpiantoFormData, ToImpiantoData } from "./impiantoForm";
import ImpiantiTermiciActions from "../ImpiantiTermiciActions";
import ClientiActions from "../../customers/customersActions";
import ClientiStore from "../../customers/customersStore";
import { ImpiantoDto, ClienteDto, TipoIntervento, InterventoData, ApparecchioCategoryType } from "../../generated";
import { links } from "../../routes";
import { Loading } from "../../common/components/loading";
import InterventiActions from "../../interventi/InterventiActions";

const CreateFirstInterventi = async (impianto: ImpiantoDto) => {
    if (impianto.dataUltimoControlloAnn.valueOf() === impianto.dataUltimoControlloComb.valueOf()) {
        await InterventiActions.add(new InterventoData({
            idImpianto: impianto.idImpianto,
            idCliente: impianto.idCliente,
            controlloCombustione: true,
            controlloStandard: true,
            dataIntervento: impianto.dataUltimoControlloAnn,
            tipoIntervento: new TipoIntervento({ idTipoIntervento: 3, descTipoIntervento: "Manutenzione", ordine: 1 }),
            applicazioneBollino: false,
            oggettoIntervento: "Manutenzione annuale e controllo combustione",
        }))
    }
    else {
        await InterventiActions.add(new InterventoData({
            idImpianto: impianto.idImpianto,
            idCliente: impianto.idCliente,
            controlloCombustione: false,
            controlloStandard: true,
            dataIntervento: impianto.dataUltimoControlloAnn,
            tipoIntervento: new TipoIntervento({ idTipoIntervento: 3, descTipoIntervento: "Manutenzione", ordine: 1 }),
            applicazioneBollino: false,
            oggettoIntervento: "Manutenzione annuale",
        }))
        await InterventiActions.add(new InterventoData({
            idImpianto: impianto.idImpianto,
            idCliente: impianto.idCliente,
            controlloCombustione: true,
            controlloStandard: false,
            dataIntervento: impianto.dataUltimoControlloComb,
            tipoIntervento: new TipoIntervento({ idTipoIntervento: 3, descTipoIntervento: "Manutenzione", ordine: 1 }),
            applicazioneBollino: false,
            oggettoIntervento: "Manutenzione combustione",
        }))
    }
}

const NewImpianto = (cliente: ClienteDto, category: ApparecchioCategoryType) => {
    var impianto = new ImpiantoDto();
    impianto.idImpianto = 0;
    impianto.idCliente = cliente.idCliente;
    impianto.codFisComune = cliente.comune?.codFisComune;
    impianto.cap = cliente.cap ?? cliente.comune?.cap;
    impianto.codFrazione = cliente.frazione?.codFrazione;
    impianto.indirizzo = cliente.indirizzo;
    impianto.inheritsAddress = true;
    impianto.type = category;
    return impianto;
}

interface Props extends RouteComponentProps<{ idCliente: string, category: string }> {
    impianto?: ImpiantoDto;
    cliente?: ClienteDto;
}


const ImpiantoEdit = (props: Props) => {
    let { cliente, history, match: { params: { idCliente, category } } } = props;

    useEffect(() => {
        if (idCliente) {
            if (ClientiStore.get(idCliente) == null)
                ClientiActions.getCliente(parseInt(idCliente));
        }
    }, [idCliente])

    const save = async (i: ImpiantoFormData) => {
        const impiantoData = ToImpiantoData(i);
        const newImpianto = await ImpiantiTermiciActions.add(impiantoData);
        if (i.createInterventi == null || i.createInterventi == true) {
            await CreateFirstInterventi(newImpianto);
        }

        history.replace(links.customerShow(parseInt(idCliente)));

    }
    if (!cliente)
        return <Loading />

    return (
        <ImpiantoForm
            impianto={NewImpianto(cliente, parseInt(category))}
            onSubmit={save}
            onCancel={() => history.goBack()}
            isNew={true}
        />

    );
}

const cmp1 = attach(ImpiantoEdit, ClientiStore, (store, props) => ({
    cliente: store.get(props.match.params.idCliente) ?? undefined,
}));
export default withRouter(cmp1);